import { createAction, props } from '@ngrx/store';
import { Config } from '../../interfaces/config';

export const RETRIEVE_CONFIG = createAction(
  '[CONFIG] - retrieve config',
  props<{ token: string }>()
);

export const RETRIEVE_CONFIG_SUCCESS = createAction(
  '[CONFIG] - retrieve config success',
  props<{ config: Config }>()
);

export const RETRIEVE_NOTIFICATIONS = createAction(
  '[CONFIG] - retrieve notifications'
);

export const RETRIEVE_NOTIFICATIONS_SUCCESS = createAction(
  '[CONFIG] - retrieve notifications success',
  props<{ isNotificationPresent: boolean, messaggioHeader?: string, nuovaComunicazione?: string }>()
);

export const RETRIEVE_SURVEY = createAction('[CONFIG] - retrieve survey');

export const RETRIEVE_SURVEY_SUCCESS = createAction(
  '[CONFIG] - retrieve survey success',
  props<{ surveyUrl: string }>()
);
export const RETRIEVE_SHOW_SURVEY = createAction(
  '[CONFIG] - retrieve show survey',
  props<{ abilitato: boolean }>()
);

export const RETRIEVE_REGEX_DHL = createAction('[CONFIG] - retrieve regex DHL');

export const RETRIEVE_REGEX_DHL_SUCCESS = createAction(
  '[CONFIG] - retrieve regex DHL success',
  props<{
    regexCodiceDhlInbound: string;
    regexCodiceDhlInboundCodeSeparator: string;
  }>()
);

export const RETRIEVE_EXPIRED_OBJECT = createAction(
  '[CONFIG] - retrieve expired object'
);

export const RETRIEVE_EXPIRED_OBJECT_SUCCESS = createAction(
  '[CONFIG] - retrieve expired object success',
  props<{
    frequenzaPopupOggettiScaduti: number;
    giornataLavorativa: boolean;
    numeroOgettiScadutiOggi: number;
    numeroOgettiScadutiPrimaDiOggi: number;
    oggettiScadutiOggi: boolean;
    oggettiScadutiPrimaDiOggi: boolean;
  }>()
);

export const SET_IS_LOTTOMATICA = createAction(
  '[CONFIG] - set is Lottomatica',
  props<{ isLottomatica: boolean }>()
);
